import React from "react";
import "./Info.css";
const Info = () => {
  return (
    <div
      className="info"
      style={{ backgroundColor: "white", alignItems: "flex-end" }}
    >
      <div className="heading-container">
        <div className="heading">Small Steps, Big Impact, Together for a Greener Act!</div>
        <span>Day 2</span> 
        <div className="heading-line"></div>
      </div>
      <div className="text1">
      On the second day, we focus on cleanliness and energy conservation. The registrar will lead a team in
cleaning solar energy plants and panels, ensuring maximum efficiency in our renewable energy
systems. By maintaining and optimising these systems, we can harness more clean energy. "Shine
bright, harness the solar might!"

      </div>
      <div className="text2">
      In addition, students will advocate taking the stairs instead of elevators, promoting physical fitness
and reducing energy consumption. They will also spread the message of switching off unnecessary
lights and electric gadgets to conserve energy.
      </div>
      <div className="text2">
      We will also promote the practice of crushing leaves through a leaf crusher. This eco-friendly method
helps reduce the volume of leaves and facilitates their decomposition, ultimately enriching the soil.
Let's embark on this sustainable journey, saying, "Leaves crushed, nature's cycle hushed!"

      </div>
      <div className="extra">
        <div className="date">
          <span style={{ fontWeight: "bold" }}>Date</span>: 11 August, 2022
        </div>
        {/* <div className="time">Time: 4:00 PM</div>
        <div className="location">Venue: Adminsitrative Building</div> */}
      </div>
    </div>
  );
};

export default Info;
